import { render, staticRenderFns } from "./CheckAddressZoneModal.vue?vue&type=template&id=72c0f836"
import script from "./CheckAddressZoneModal.vue?vue&type=script&lang=js"
export * from "./CheckAddressZoneModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports